import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const TextItalicIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="textItalic" ref={ref} {...props}>
      <path d="M18.75,3.29A.76.76,0,0,1,18,4H15.54L10.06,19.79H12a.75.75,0,0,1,0,1.5H6a.75.75,0,1,1,0-1.5H8.48L13.94,4H12a.75.75,0,0,1,0-1.5h6A.76.76,0,0,1,18.75,3.29Z" />
    </Icon>
  ),
) as IconWithRender;

TextItalicIcon.displayName = 'TextItalicIcon';
TextItalicIcon.renderIcon = (props) => <TextItalicIcon {...props} />;
export default TextItalicIcon;
